import type { FunctionComponent } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { InfoBanner } from '@kanda-libs/ks-design-library';

import { URLS } from 'components/shared/App/constants';
import PageTitle from 'components/shared/PageTitle';
import { selectors } from 'store';

const PartnerBanner: FunctionComponent = function () {
  const partner = useSelector(selectors.partner.getEntity);
  const isLoading = useSelector(selectors.getIsLoading);

  const { push } = useHistory();

  return (
    <>
      <PageTitle>{partner?.contact_info.trading_name}</PageTitle>
      <InfoBanner
        title={partner?.contact_info.trading_name}
        isLoading={isLoading}
        onGoBack={() => {
          push(URLS.partners);
        }}
      />
    </>
  );
};

export default PartnerBanner;
